import Vue from "vue";
import Router from "vue-router";
import { Message } from 'element-ui';
import Cookies from 'js-cookie'
import { getStatus } from "../api/index";
Vue.use(Router);
const router = new Router({
    routes: [
        {
            path: "/",
            name: "login",
            component: () => import("@/views/login")
        }
        // ,
        // {
        //   path:'/oldmenu',
        //   name:'oldmenu',
        //   component:()=>import("@/views/menuPage/index")
        // }
        , {
            path: '/menu',
            name: 'menu',
            component: () => import("@/views/newMenu")
        },
        {
            path: '/potato',
            name: 'potato',
            component: () => import("@/views/potatoVideo")
        }
    ]
});

router.beforeEach(async (to, from, next) => {

    if (to.path == "/menu") {
        if (Cookies.get('token')) {
            try {
                const status = await getStatus()
                if (status.data.data) {
                    next()
                } else {
                    Message("登陆失效，请重新登录")
                    Cookies.remove('token')
                    next({ path: '/' })
                }
            } catch (error) {
                console.log(error)
            }
        } else {
            Message("请先登录")

            next({ path: '/' })
            //next()
        }
    } else if (to.path == '/') {
        Cookies.remove('token')
        next()
    } else {
        next()
    }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js